export enum NpsSurveyType {
    ScoreOnly = 'ScoreOnly',
    WithQuestions = 'WithQuestions',
}

/**
 * @note The reason the new enum is introduced is because
 * it is unsure whether survey questions will always follow the
 * same languages NiceJob supports for its users given that
 * questions are targeted to customers and not NiceJob users.
 * Perhaps in future user can use other languages to serve their
 * customers in different languages.
 */
export { LanguagePreference as SupportedQuestionLanguage } from '../User/enums';

export enum NpsSurveyAnswerValue {
    StronglyDisagree = 'StronglyDisagree',
    Disagree = 'Disagree',
    Neutral = 'Neutral',
    Agree = 'Agree',
    StronglyAgree = 'StronglyAgree',
}
